import { UploadController } from '@organisms';
import { TooltipProps } from 'antd';
import { UploadProps } from 'antd/lib/upload';
import { ReactElement, ReactNode } from 'react';
import { Control } from 'react-hook-form';

interface UploadImageProps extends UploadProps {
  control: Control<any>;
  name: string;
  label: string;
  required: boolean;
  tooltip?: ReactNode | (TooltipProps & { icon?: ReactElement });
  allowedExtensions?: string[];
  includeResourceBaseUrl?: boolean;
}

export const UploadImage: React.FC<UploadImageProps> = ({
  control,
  name,
  label,
  required,
  tooltip,
  allowedExtensions,
  includeResourceBaseUrl,
}) => {
  return (
    <UploadController
      control={control}
      name={name}
      defaultValue=''
      required={required}
      label={label}
      listType='picture-card'
      showUploadList={false}
      maxCount={1}
      allowedExtensions={allowedExtensions}
      style={{
        minWidth: '369px',
        minHeight: '88px',
        maxHeight: '88px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      includeResourceBaseUrl={includeResourceBaseUrl}
      {...(tooltip && { tooltip: tooltip })}
    />
  );
};
